module.exports = __webpack_public_path__ + "img/dark-mud-decal-19.f15ef431.png";